import React, { Component } from 'react';

export default class MaestroArrowNode extends Component {

  render() {
    return (
      <div
        className={this.props.arrowClassName}
        onClick={this.props.onClick}>
        {
          this.props.child ?
            <i className="ion-arrow-down-b"/> :
            <i className="ion-minus"/>
        }
      </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/pages/MantMaestros/MaestroArrowNode.js